export default __webpack_public_path__ + "static/media/LevelUp.b3cbd031.svg";